module.exports = __webpack_public_path__ + "static/media/1025507.d5dc0326.jpg";